// Nota informativa standard: le credenziali non si configurano da UI
import { ShieldAlert } from 'lucide-react'

interface CredentialsNoteProps {
  envVars: string[]
}

export function CredentialsNote({ envVars }: CredentialsNoteProps) {
  return (
    <div className="flex gap-3 rounded-lg border border-[var(--fc-warning)] bg-[color-mix(in_srgb,var(--fc-warning)_8%,transparent)] p-3">
      <ShieldAlert className="h-4 w-4 shrink-0 text-[var(--fc-warning)] mt-0.5" aria-hidden="true" />
      <div className="text-xs text-[var(--fc-foreground-muted)]">
        <p className="font-medium text-[var(--fc-foreground)]">Credenziali — solo variabili d'ambiente</p>
        <p className="mt-1">
          Per motivi di sicurezza, le credenziali sensibili non sono gestibili da questa interfaccia.
          Configurare le seguenti variabili d'ambiente sul server:
        </p>
        <ul className="mt-2 space-y-0.5">
          {envVars.map((v) => (
            <li key={v} className="font-mono text-[var(--fc-primary)]">{v}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}
